<template>
    <div id="ch" class="ch">
        <NavBar></NavBar>
        <router-view></router-view>
        <FooterSection></FooterSection>
    </div>
</template>
<script>
import { defineAsyncComponent } from '@vue/runtime-core'
import { NavBar } from '@/components/ch'
const FooterSection = defineAsyncComponent(() =>
    import('@/components/ch/FooterSection.vue')
)
export default {
    components: { NavBar, FooterSection },
}
</script>
